<div fxLayout="row" fxLayoutAlign="space-between end" class="header-create-section">

    <div>
        <h2 class="">
            {{ titulo }}</h2>

        <h1 class="text-4xl leading-normal mt-0 mb-2 font-semibold">
            {{ subTitulo }}
        </h1>
    </div>
    <button class="flex evk-button" (click)="registrarNuevoExcel()" mat-button style="width: fit-content;" *ngIf="canImport">
        <mat-icon style="color: #F9FAFB">file_upload</mat-icon>
        Importar desde archivo
    </button>
</div>
<div class="backdrop-opacity-10 bg-card rounded-lg mb-5 pt-3 shadow-2xl search-bar" fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap>

    <mat-form-field appearance="outline" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="25%" fxFlex.lg="25%" class="px-4">
        <mat-select placeholder="Seleccionar criterio" (selectionChange)="onFiltroChange($event)" #selectFiter>
            <mat-option>Limpiar...</mat-option>
            <ng-container *ngFor="let filter of filters;">
                <mat-option [value]="filter.id">{{filter.title}}</mat-option>
            </ng-container>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf='filtroSeleccionado == "fechaDeCreacion"' appearance="outline" fxFlex.xs="100%"
                    fxFlex.sm="50%" fxFlex.md="25%" fxFlex.lg="25%" class="px-4">
        <mat-label>Fecha de creación</mat-label>
        <input
            matInput
            [matDatepicker]="fechaCreacionPicker"
            placeholder="Fecha de creación"
            (blur)="onDateInputed($event)"
            [(ngModel)]="valoresFiltros.fechaDeCreacion">
        <mat-datepicker-toggle matSuffix [for]="fechaCreacionPicker"></mat-datepicker-toggle>
        <mat-datepicker #fechaCreacionPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field *ngIf='filtroSeleccionado == "folio"' appearance="outline" fxFlex.xs="100%" fxFlex.sm="50%"
                    fxFlex.md="25%" fxFlex.lg="25%" class="px-4">
        <mat-label>Número de folio</mat-label>
        <input placeholder="No. de folio" #query matInput cleanWhiteSpace [(ngModel)]="valoresFiltros.folio">
    </mat-form-field>

    <mat-form-field *ngIf='filtroSeleccionado == "nombre"' appearance="outline" fxFlex.xs="100%" fxFlex.sm="50%"
                    fxFlex.md="25%" fxFlex.lg="25%" class="px-4">
        <mat-label>Nombre ó Institución</mat-label>
        <input placeholder="Nombre" #query matInput cleanWhiteSpace [(ngModel)]="valoresFiltros.nombre">
    </mat-form-field>

    <div fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="25%" fxFlex.lg="25%" class="px-4 contenedor-filtro-buscar">
        <button (click)="filterBy()" [disabled]="!filtroSeleccionado" mat-raised-button
                class="evk-button"
                [ngClass]="{'disabled-evk-cuu': !filtroSeleccionado}">
            Buscar
        </button>
    </div>

</div>

<div class="rounded-lg mt-10 shadow-2xl">

    <div class="bg-card rounded-lg p-10">
        <mat-table class="datos-table rounded-lg" #table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="folio">
                <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" mat-sort-header>Folio
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                    <p class="text-truncate">{{row?.expediente?.folioProvisional}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="fechaCreacion">
                <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" mat-sort-header>Fecha creación
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                    <p class="text-truncate">{{row?.expediente?.created | date:'dd/MM/yyyy HH:mm:ss'}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="tipoBeneficiario">
                <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" mat-sort-header>Tipo beneficiario
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                    <p class="text-truncate">{{getTipoBeneficiario(row)}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="nombre">
                <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" mat-sort-header>Nombre/Dependencia
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                    <p class="text-truncate">{{getNombre(row)}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="nombrePrograma">
                <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" mat-sort-header>Nombre Programa
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                    <p class="text-truncate">{{row?.datosPrograma?.a4NombrePrograma?.label}}</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" mat-sort-header>Acciones
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxLayoutAlign="center center" style="border: black;">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>settings</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <ng-template matMenuContent>
                            <button mat-menu-item (click)="detailPrestacion(row)">
                                <mat-icon color="primary">remove_red_eye</mat-icon>
                                Ver detalle
                            </button>
                            <button mat-menu-item (click)="updatePrestacion(row)">
                                <mat-icon color="primary">cached</mat-icon>
                                Actualizar
                            </button>
                        </ng-template>
                    </mat-menu>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="columns; sticky:true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns;" matRipple></mat-row>
        </mat-table>

        <mat-paginator #paginator [length]="totalItems" [pageIndex]="pageIndex"
                       [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                       (page)="changePageHandler($event)">
        </mat-paginator>

        <div *ngIf="dataSource.data.length === 0">
            <div class="message-box ">
                No existen registros.
            </div>
        </div>

        <div *ngIf="!load">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            Cargando...
        </div>
    </div>

</div>
